import { HypertuneProvider } from '../../generated/hypertune.react'
import { useEffect } from 'react'
import { getHypertuneUserId, setHypertuneUserId } from '../utils/hypertune'
import { generateAnonymousUserId } from '../utils/storage'

export function AppHypertuneProvider({
  children,
}: {
  children: React.ReactNode
}) {
  useEffect(() => {
    // Ensure we have a user ID
    const userId = getHypertuneUserId()
    if (!userId) {
      // Generate a new anonymous user ID if none exists
      const newUserId = generateAnonymousUserId()
      setHypertuneUserId(newUserId)
    }
  }, [])

  return (
    <HypertuneProvider
      createSourceOptions={{
        token: process.env.NEXT_PUBLIC_HYPERTUNE_TOKEN!,
      }}
      rootArgs={{
        context: {
          environment: process.env.NODE_ENV,
          user: { id: getHypertuneUserId() || 'anonymous' },
        },
      }}
    >
      {children}
    </HypertuneProvider>
  )
}
